import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Brand";
import { FaqSection } from "@/components/FaqSection";
import { SiteFooter } from "@/components/SiteFooter";
import { useSeo } from "@/lib/seo";

export default function Faq() {
  useSeo({
    title: "Domande frequenti — StayGuide",
    description: "Risposte alle domande più comuni su StayGuide: guide digitali per ospiti, Concierge AI, QR code, prezzi e prova gratuita di 7 giorni.",
    path: "/faq",
  });
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-100 sticky top-0 z-20">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Logo className="h-9" />
          <Link to="/" className="text-sm text-slate-500 flex items-center gap-1 hover:text-blue-600 transition-colors"><ArrowLeft className="w-4 h-4" /> Home</Link>
        </div>
      </header>
      <FaqSection id="faq" />
      <div className="text-center pb-14">
        <p className="text-slate-500">Non hai trovato la risposta?</p>
        <Link to="/signup?plan=trial" className="mt-3 inline-flex items-center gap-2 bg-blue-500 text-white font-semibold rounded-full px-6 py-3 shadow-lg shadow-blue-500/25">Inizia gratis per 7 giorni</Link>
      </div>
      <SiteFooter />
    </div>
  );
}
